export const CATEGORIES_QUERY_KEY = "categories";
